export const COUNTS_AS_INTERNAL_DOMAINS =
  /^https?:\/\/(next\.|dev\.)?(museum-gestaltung\.ch|pavillon-le-corbusier\.ch|corbusier\.(lndo|ddev)\.site|mfg\.(lndo|ddev)\.site)\/?/

// to have it as module
export {}
